import { ReactElement } from 'react';
import Parse from 'html-react-parser';
import { AnnouncementSubCardPropTypes } from '../../types/propTypes/AnnouncementSubCardPropTypes';

const AnnouncementSubPanel = ({
  panelText,
  panelUrl,
  panelUrlText
}: AnnouncementSubCardPropTypes): ReactElement => (
  <>
    <div data-testid="help-center-directions-1">
      {Parse(panelText)}
    </div>

    {
        panelUrl && (
          <div data-testid="help-center-directions-1">
            <ul>
              <li>
                <a href={panelUrl}>{panelUrlText}</a>
              </li>
            </ul>
          </div>
        )
    }
  </>
);

export default AnnouncementSubPanel;
